import { NgModule } from '@angular/core'
import { FilterProgramsPipe } from './filter-programs.pipe'
import { EventsPipe } from './events.pipe'
import { SafePipe } from './safe.pipe'
import { ReplacePipe } from './replace.pipe'
import { RandomPipe } from './random.pipe'
import { TruncateTextPipe } from './truncatetext.pipe'
import { ColorOpacityPipe } from './color-opacity.pipe'
import { BackgroundImagePipe } from './background.pipe'
import { RemoveHtmlPipe} from './removeHtml.pipe'
import { DeleteCharactersFilePipe} from './deleteCharactersFile.pipe'
import { HighligthSearchText} from './highligthSearchText.pipe'
import { ContentTypePipe } from './contentType.pipe'

@NgModule({
  imports: [],
  declarations: [
    FilterProgramsPipe,
    SafePipe,
    EventsPipe,
    ReplacePipe,
    RandomPipe,
    TruncateTextPipe,
    ColorOpacityPipe,
    BackgroundImagePipe,
    RemoveHtmlPipe,
    DeleteCharactersFilePipe,
    HighligthSearchText,
    ContentTypePipe
  ],
  exports: [
    FilterProgramsPipe,
    EventsPipe,
    SafePipe,
    ReplacePipe,
    RandomPipe,
    TruncateTextPipe,
    ColorOpacityPipe,
    BackgroundImagePipe,
    RemoveHtmlPipe,
    DeleteCharactersFilePipe,
    HighligthSearchText,
    ContentTypePipe
  ],
  providers: [],
})
export class PipesModule {}
